'use strict';

export default function initSiteCopy() {
    if (document.body.classList.contains('wp-admin')) return;

    document.addEventListener('copy', (event) => {
        // Preserve copying from comment fields and other editable controls.
        const target = event.target instanceof Element ? event.target : document.activeElement;
        if (target?.closest('input, textarea, #wpadminbar') || target?.isContentEditable) return;

        const selection = window.getSelection();
        if (!event.clipboardData || !selection || selection.isCollapsed) return;

        const anchor = selection.anchorNode instanceof Element
            ? selection.anchorNode
            : selection.anchorNode?.parentElement;
        if (anchor?.closest('#wpadminbar')) return;

        // A selected headline shares its destination; other text shares this page.
        const link = anchor?.closest('a[href]');
        const selectedLink = link && link.contains(selection.focusNode)
            && ['http:', 'https:'].includes(link.protocol) ? link.href : null;
        const shareUrl = selectedLink
            || document.querySelector('.single-article[data-share-url]')?.dataset.shareUrl
            || document.querySelector('link[rel="canonical"]')?.href
            || window.location.href;

        const message = `Para compartilhar esse conteúdo, utilize o link ${shareUrl} ou as ferramentas de compartilhamento disponíveis na página. Para reproduzir textos, fotos, artes ou vídeos do Tribuna do Pampa, entre em contato com o jornal e solicite autorização.`;

        event.clipboardData.clearData();
        event.clipboardData.setData('text/plain', message);
        event.preventDefault();
    });
}
